//
//
//
//
//

import Vue from 'vue';
import SfBottomNavigationItem from './internal/SfBottomNavigationItem.vue';

Vue.component('SfBottomNavigationItem', SfBottomNavigationItem);
export default {
  name: 'SfBottomNavigation',
};
